import { buildModelManager } from "../builder.js";
const DefaultFlowButtonResponseSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  contactId: true,
  conversationId: true,
  createdAt: true,
  customerId: true,
  flowButtonId: true,
  messageId: true,
  responseData: true,
  scenarioId: true,
  updatedAt: true
};
const modelApiIdentifier = "flowButtonResponse";
const pluralModelApiIdentifier = "flowButtonResponses";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFlowButtonResponseSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createFlowButtonResponse",
    operationReturnType: "CreateFlowButtonResponse",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      flowButtonResponse: { required: false, type: "CreateFlowButtonResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "action",
    operationName: "bulkCreateFlowButtonResponses",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateFlowButtonResponsesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "action",
    operationName: "updateFlowButtonResponse",
    operationReturnType: "UpdateFlowButtonResponse",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      flowButtonResponse: { required: false, type: "UpdateFlowButtonResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateFlowButtonResponses",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateFlowButtonResponsesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "action",
    operationName: "deleteFlowButtonResponse",
    operationReturnType: "DeleteFlowButtonResponse",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteFlowButtonResponses",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertFlowButtonResponse",
    operationReturnType: "UpsertFlowButtonResponse",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      flowButtonResponse: { required: false, type: "UpsertFlowButtonResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateFlowButtonResponseResult": { hasReturnType: false },
      "... on UpdateFlowButtonResponseResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertFlowButtonResponses",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertFlowButtonResponsesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultFlowButtonResponseSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "flowButtonResponseGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const FlowButtonResponseManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultFlowButtonResponseSelection,
  operations
);
export {
  DefaultFlowButtonResponseSelection,
  FlowButtonResponseManager
};
//# sourceMappingURL=FlowButtonResponse.js.map
